<app-header></app-header>
<app-navbar></app-navbar>

<div class="alert alert-primary text-center mt-5" role="alert">
    <span >{{'welcome' | translate}} , {{user}} </span> 
</div>
